import React from "react";
import { Alert, Col, Row } from "antd";
import "../css/Login.css";
import logo from "../assets/LOGO_UTESC.webp";
import { useLoginAdmin } from "../hooks/useLoginAdmin"
import { clientId } from "../api/url";
import GoogleLogin from "react-google-login";
import { Toaster } from "react-hot-toast";
import { LoadingOutlined } from "@ant-design/icons";



const LoginAdmin = () => {

  const { onLoginSuccess, mostrarBtnLogin, onLoginFailure, comprobandoPermisos } = useLoginAdmin();


  return (
    <div className="fondo-blanco">
      <div className="header-login">
        <p className="lead no-select"> Examen de diagnóstico UTEsc </p>
      </div>

      <Row className="login-centrado">
        <Col flex={1}></Col>
        <Col flex={2} className="contenedor-login">
          {/* esto es lo importante */}
          {/* <div className="site-card-border-less-wrapper">
            <Card title="Inicia sesión para continuar" bordered={true}>
              <Row> */}
          <Col flex={1}>
            <div className="div-logo-login">
              <img src={logo} className="logo-login" />
            </div>
          </Col>
          <Col flex={1}>
            <Row justify="center">
              <Col xxl={12} sm={12} className="div-btn-center">

                { mostrarBtnLogin &&
                  <GoogleLogin
                    clientId={clientId}
                    buttonText="Continuar con Google"
                    onSuccess={onLoginSuccess}
                    onFailure={onLoginFailure}
                    cookiePolicy={"single_host_origin"}
                    theme="dark"
                  />
                }

                { comprobandoPermisos && 
                  <Alert message={ <span>Comprobando permisos <LoadingOutlined /></span> } type="info" style={{ marginTop: 30 }}/>
                }
                </Col>
            </Row>
          </Col>
          {/* </Row>
            </Card>
          </div> */}
        </Col>
        <Col flex={1}></Col>
      </Row>
      <Toaster/>
    </div>
  );
};

export default LoginAdmin;
